// External
import { Directive, Input, ElementRef, Renderer2, OnInit, HostListener } from '@angular/core';
import { UiList } from './ui-list.models';

// Internal

@Directive({
    selector: '[ui-list-item], ui-list-item',
    host: {
        '[attr.tabindex]': 'clickable ? 0 : "-1"'
    }
})
export class UiListItemDirective  implements OnInit {

    @Input() role: UiList.ItemType; // header, footer, separator
    @Input() disabled: boolean;
    @Input() muted: boolean;
    @Input() bordered = true;
    @Input() clickable = false;

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'list-item');

        if (this.role) {
            this.renderer.addClass(this.el.nativeElement, 'list-item-' + this.role);
        }

        if (this.disabled) {
            this.renderer.addClass(this.el.nativeElement, 'disabled');
        }

        if (this.muted) {
            this.renderer.addClass(this.el.nativeElement, 'disabled-actions');
        }

        if (!this.bordered) {
            this.renderer.addClass(this.el.nativeElement, 'unbordered');
        }
    }

    // if click-able force click on enter
    @HostListener('keyup.enter', ['$event']) onEnter(event) {
        if (this.clickable){
            this.el.nativeElement.click();
        }
    }
}
